import { createSelector } from '@ngrx/store';

import { selectIsLinearBetslip } from '../../base/store/selectors';
import { BetslipType } from '../../core/betslip-type';
import { comboBetPicksSelector, selectComboBetRewardTokenId } from '../combo-bet/selectors';
import { betslipPicksListSelector } from '../picks/selectors';
import { filterTypePicks } from '../picks/services/linear-betslip-pick.utils';
import { selectRewardTokens, selectTokensStateContext } from '../reward-tokens/selectors';
import { isAccaBoostToken, isValidAccaBoostCombo } from '../reward-tokens/services/reward-tokens.utils';
import { betslipTypeStateSelector } from '../types/selectors';
import { selectHasComboPreventionForTypeFactory, selectTypePickErrors } from '../validation/selectors';
import { getAccaTokenStatus } from './services/acca-boost.utils';

export const selectAccaBoostPicks = createSelector(
    comboBetPicksSelector,
    betslipPicksListSelector,
    selectIsLinearBetslip,
    (comboState, pickList, isLinear) => filterTypePicks(comboState, pickList, { isSelected: true, isLocked: isLinear ? false : undefined }),
);

export const selectIsValidAccaBoostCombo = createSelector(
    betslipPicksListSelector,
    selectTypePickErrors,
    betslipTypeStateSelector,
    selectIsLinearBetslip,
    (pickList, typePickErrors, types, isLinear) => isValidAccaBoostCombo(typePickErrors, pickList, types, isLinear),
);

export const selectAccaBoostPicksCount = createSelector(selectAccaBoostPicks, (accaBoostPicks) => accaBoostPicks.length);

export const selectAccaTokenStatus = createSelector(
    selectTokensStateContext,
    selectAccaBoostPicks,
    selectIsLinearBetslip,
    selectHasComboPreventionForTypeFactory(BetslipType.Combo),
    ({ tokens, eligibilityState, types }, picks, isLinear, hasComboPrevention) =>
        getAccaTokenStatus(eligibilityState, tokens, types, picks, hasComboPrevention, isLinear),
);

export const selectHasAccaBoostSelected = createSelector(selectComboBetRewardTokenId, selectRewardTokens, (comboTokenId, tokens) => {
    if (!comboTokenId) {
        return false;
    }

    const token = tokens[comboTokenId];

    return isAccaBoostToken(token);
});
